import { useEffect, useState } from 'react';

import { useThemeObserver } from '@atlaskit/tokens';

export const useThemeAnimation = (
	loadLightAnimation: () => Promise<unknown>,
	loadDarkAnimation: () => Promise<unknown>,
	onError?: (error: unknown) => void,
): unknown => {
	const { colorMode } = useThemeObserver();
	const [animationData, setAnimationData] = useState<unknown>(null);

	useEffect(() => {
		let isCancelled = false;

		const loadAnimation = async () => {
			try {
				const data = colorMode === 'dark' ? await loadDarkAnimation() : await loadLightAnimation();

				if (!isCancelled) {
					setAnimationData(data);
				}
			} catch (error) {
				if (!isCancelled) {
					onError?.(error);
				}
			}
		};

		if (!colorMode) {
			return;
		}

		void loadAnimation();

		return () => {
			isCancelled = true;
		};
	}, [colorMode, loadLightAnimation, loadDarkAnimation, onError]);

	return animationData;
};
